import React from "react";
import { Row, Col, Table } from "react-bootstrap";
import { IoCopy, IoInformationCircleSharp } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import { FiMinus } from "react-icons/fi";
import { IconButton, Tooltip } from "@mui/material";

const SHARE_PACKAGES = [
  "5 shares for $40",
  "15 shares for $120",
  "50 shares for $400",
  "100 shares for $800",
  "250 shares for $2000",
];

const TRANSACTION_HEADERS = [
  "Date",
  "Type",
  "Amount",
  "Level",
  "Value",
  "Status",
  "TxID",
];

function LoadPage() {
  return (
    <Col className="live-presale-max-width mt-0 presale-live-background">
      <Row className="justify-content-center ">
        <Col
          xs={12}
          sm={10}
          lg={6}
          className="d-flex flex-column justify-content-between"
        >
          <Row className="bg-live align-items-center justify-content-center shared-margin shared-space">
            <Col xs={10} className="live-buy-section live-buy-sectionCard">
              <Row className="shares-stats-row">
                <Col md={4} className="share-stat-card">
                  <h3 className="share-stat-title">
                    Your <span className="purple-span">shares</span>
                  </h3>
                  <p className="share-stat-value">--</p>
                </Col>
                <Col md={4} className="share-stat-card">
                  <h3 className="share-stat-title custome-title">
                    Your <span className="purple-span">Power</span>
                  </h3>
                  <p className="share-stat-value custome-value">--.--</p>
                  <div className="share-progress-container">
                    <div
                      className="share-progress-bar"
                      style={{ width: "10%" }}
                    ></div>
                  </div>
                </Col>
                <Col md={4} className="share-stat-card">
                  <h3 className="share-stat-title custome-title">
                    Total <span className="purple-span">Profit</span>
                  </h3>
                  <p className="share-stat-value custome-value">--.-- TRT</p>
                  <div className="share-progress-container">
                    <div
                      className="share-progress-bar"
                      style={{ width: "10%" }}
                    ></div>
                  </div>
                </Col>
              </Row>

              <div className="second-row-in-share">
                <div className="share-link">
                  <p>Loading referral link...</p>
                </div>
                <div className="share-btns">
                  <IoCopy className="cursor-pointer disabled-icon" />
                  <BsQrCodeScan className="BsQrCodeScan disabled-icon" />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="justify-content-center mt-4 ">
        <Col xs={12} sm={10} lg={6}>
          <Row
            className="bg-live align-items-center justify-content-center shared-margin shared-space h-100"
            id="buy-section-card"
          >
            <Col xs={10} className="live-buy-section expanded">
              <div className="bnb-address d-flex justify-content-between align-items-center">
                <p>--.-- BNB</p>
                <div>
                  <span className="mr-2">0x----...----</span>
                  <IoCopy className="cursor-pointer disabled-icon" />
                </div>
              </div>
              <h1>Buy Trinity Shares</h1>
              <div className="buy-toggle-wrapper">
                <button
                  type="button"
                  className="buy-toggle-btn open"
                  disabled
                  aria-label="Loading purchase details"
                >
                  <FiMinus className="buy-toggle-icon" />
                </button>
              </div>
              <div className="buy-details open">
                <div className="presal-amount mb-4">
                  <h6 className="d-flex align-self-start mb-2">
                    Select package <span className="minAllo-span">Shares</span>
                  </h6>

                  <div className="amount-filter-buttons mb-3">
                    {SHARE_PACKAGES.slice(0, 2).map((label) => (
                      <button
                        key={label}
                        type="button"
                        className="amount-filter-btn"
                        disabled
                      >
                        {label}
                      </button>
                    ))}
                  </div>

                  <h4 className="referral-gain-title">
                    Gain through Three Levels of referrals
                  </h4>

                  <div className="amount-filter-buttons referral-buttons mb-4">
                    {SHARE_PACKAGES.slice(2).map((label) => (
                      <button
                        key={label}
                        type="button"
                        className="amount-filter-btn"
                        disabled
                      >
                        {label}
                      </button>
                    ))}
                  </div>

                  <div className="d-flex justify-content-between align-items-center pb-0">
                    <input
                      type="number"
                      value=""
                      placeholder="--"
                      disabled
                      className="setNFTHandlerInput"
                    />
                    <Tooltip
                      title="Price is loading from the smart contract"
                      placement="top"
                      arrow
                    >
                      <span>-- BNB</span>
                    </Tooltip>
                  </div>
                  <hr />
                </div>

                <div className="fees-data">
                  <div>
                    <h6>Total Shares Purchased</h6>
                    <h2>--</h2>
                  </div>
                  <div>
                    <h6>
                      Payment Amount{" "}
                      <Tooltip
                        title="This value is returned from the smart contract and excludes gas fees."
                        placement="top"
                        arrow
                      >
                        <IconButton className="totalPriceH2">
                          <IoInformationCircleSharp />
                        </IconButton>
                      </Tooltip>
                    </h6>
                    <h2>-- BNB</h2>
                  </div>
                </div>

                <div className="bnb-address-sponsor d-flex justify-content-between align-items-center">
                  <h6>Sponsor Address</h6>
                  <div className="bnb-address-sponsor-content">
                    <span className="mr-2">--</span>
                  </div>
                </div>

                <div className="mt-4">
                  <span className="presale-submit-btn disabled">Submit</span>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="justify-content-center pb-5">
        <Col xs={12} sm={10} lg={10} xl={10}>
          <div className="shared-space">
            <div className="CommissionsDetails">
              <h2 className="table-label">Transactions</h2>
              <div className="transactions-filter-buttons mb-3 table-label totalCommission">
                {[
                  "All",
                  "Purchase",
                  "Commission",
                  "Revenue",
                  "Distribution",
                ].map((label) => (
                  <button
                    key={label}
                    type="button"
                    className="transaction-filter-btn"
                    disabled
                  >
                    {label}
                  </button>
                ))}
              </div>
              <div className="borderSpace"></div>
            </div>
            <div className="bg-live">
              <div className="table-responsive-wrapper">
              <Table className="purchasing-table">
                <thead>
                  <tr>
                    {TRANSACTION_HEADERS.map((header) => (
                      <th key={header}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <tr key={index}>
                      <td>--</td>
                      <td>--</td>
                      <td>--</td>
                      <td>--</td>
                      <td>--</td>
                      <td>
                        <span className="purchase-state complete-purchase">
                          --
                        </span>
                      </td>
                      <td>
                        <Tooltip title="--" placement="top" arrow>
                          <IconButton className="totalPriceH2">----</IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              </div>
            </div>
            <div className="d-flex disablePagination">
              <span>Previous</span>
              <ul>
                <li className="active-page">0</li>
              </ul>
              <span>Next</span>
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
}

export default LoadPage;
